import { render, staticRenderFns } from "./detailBill.vue?vue&type=template&id=490f8a00&scoped=true"
import script from "./detailBill.vue?vue&type=script&lang=js"
export * from "./detailBill.vue?vue&type=script&lang=js"
import style0 from "./detailBill.vue?vue&type=style&index=0&id=490f8a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f8a00",
  null
  
)

export default component.exports